var React = require('react');


export default class Error extends React.Component{
    render(){
      return (
            <div>
                <p> 404 </p>
            </div>
        );
    }
}